export const SdohCancelStatuses = [
  'Inpatient Admission',
  'SNF Admission',
  'LTC Admission',
  'Palliative/Hospice Care Admission',
  'Refused',
  'Unsafe Home Environment',
  'Member Not Home',
  'Other'
];
